import ChoroplethChart from './ChoroplethChart'

export default ChoroplethChart
